<template>
  <v-app :class="ui.colorWhite">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">

     <router-view/>
  </v-app>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
export default {
  data() {
    return {};
  },
  mixins: [apptheme]
};
</script>
